import React from 'react';

import {  Icon } from 'rsuite';

//Componentes de roteamento
import { Link } from "react-router-dom";

import logo from './../assets/logo.webp';

import logoifsc from './../assets/ifsclogo.png';
import logocdcc from './../assets/logocdcc.png';
import logocnpq from './../assets/logocnpg.png';
import logofapesp from './../assets/logofapesp.png';
import logocapes from './../assets/logocapes.png';



export default class Infos extends React.Component {
    render() {
            return (
                <div className="dialogo col">
                    <div className="row center containerdialogoFixo">
                    <div className='dialogoFixo bkColor3 '>
                        <a href="http://eic.ifsc.usp.br/" target="_blink">
                            <div className="logo border1">
                                <img src={logo} alt="Logo" href="http://eic.ifsc.usp.br/"/>
                            </div>
                        </a>
                    </div>
                </div>
                    <div className='row center'>
                        <div className='dialogoContentInfo heigthOverInfo bkColor2 Color2'>
                            <div className="dialogoMainInfo col-md center fullWidth center">
                                <div className="col l6">
                                    {this.props.col1} 
                                </div>
                                <div className="col l6">
                                    {this.props.col2} 
                                </div>
                            </div>
                            <div className=" dialogoRodape row center fullWidth end">
                                {this.props.volta}
                            </div>
                        </div>
                        
                    </div>
                    <div  className='row distributed5 logoDivulgacao fullWidth hide-sm'>
                        <a href="https://www2.ifsc.usp.br/portal-ifsc/" target="_blink">
                            <div className="logoPatrocinador">
                                <img src={logoifsc} alt="Logo"/>
                            </div>
                        </a>
                        <a href="https://cdcc.usp.br/">
                            <div className="logoPatrocinador" >
                                <img src={logocdcc} alt="Logo" style={{width: '55%'}} />
                            </div>
                        </a>
                        <a href="http://www.cnpq.br/">
                            <div className="logoPatrocinador">
                                <img src={logocnpq} alt="Logo"  />
                            </div>
                        </a>
                        <a href="http://www.fapesp.br/">
                            <div className="logoPatrocinador">
                                <img src={logofapesp} alt="Logo"  />
                            </div>
                        </a>
                        <a href="https://www.capes.gov.br/">
                            <div className="logoPatrocinador">
                                <img src={logocapes} alt="Logo" />
                            </div>
                        </a>        
                    </div>
                        
                </div>
                
            );
    }
}